module.exports = { "default": require("core-js/library/fn/weak-map"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/~/pui-react-animation/~/babel-runtime/core-js/weak-map.js
 ** module id = 279
 ** module chunks = 0
 **/